export default __webpack_public_path__ + "static/media/packable_roll_sleeve_anorak_1_370x489_crop_top.progressive.png.b75fb443.jpg";